import { render } from "./HelpBreadcrumbs.vue?vue&type=template&id=28ba58bc&scoped=true"
import script from "./HelpBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./HelpBreadcrumbs.vue?vue&type=script&lang=js"

import "./HelpBreadcrumbs.vue?vue&type=style&index=0&id=28ba58bc&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ba58bc"]])

export default __exports__